import React from 'react'

import Text from '../../../../components/pdf/Text'
import Grid, { Col } from '../../../../components/pdf/Grid'
import Image from '../../../../components/pdf/Image'
import View from '../../../../components/pdf/View'
import Separator from '../../../../components/pdf/Separator'

const ThirdPage = () => {
  return (
    <View pageBreakAfter>
      <Grid direction="column" align="start">
        <Col>
          <Image src="/pdfs/sannygold/logo.jpg" maxWidth={100} />
        </Col>
      </Grid>
      <Separator weight={6} />
      <Grid direction="column">
        <Col>
          <Text bold align="center" color="#938953" size={18}>
            Seu publico merece Sannygold
          </Text>
          <Separator weight={6} />
          <Text>
            Os sanitários Sannygold são desenvolvidos para proporcionar ao seu convidado uma experiência diferenciada e
            alinhada com práticas ambientais sustentáveis.
          </Text>
          <Separator weight={5} />
          <Image src="/pdfs/sannygold/third-page-image.jpg" />
          <Separator weight={5} />
          <Text align="justify">
            Com várias opções de tamanhos, nossos sanitários podem se encaixar perfeitamente no tamanho de seu evento
            não havendo necessidade de ligação de água e nem esgoto externo uma vez que os mesmos possuem autonomia. Por
            serem cabines individuais, geram muito mais conforto e segurança para seus usuários tendo a opção de pias e
            espelhos internos nos Traileres de 1 a 6 cabines e externo nas opções de 8 e 10 cabines.
          </Text>
          <Separator weight={5} />
          <Text align="justify">
            Todos os sanitários Sannygold, sofrem um rigoroso processo de higienização antes de sair para seu evento,
            além de equipe profissional fazendo a limpeza durante todo o evento, garantindo que os mesmos estejam como
            elevado padrão de qualidade durante todo o período de sua utilização.
          </Text>
          <Separator weight={5} />
          <Text align="justify">
            Os resíduos gerados pela utilização dos sanitários são coletados por nossa empresa que possui a devida
            autorização do INEA e enviados para Estações de Tratamento de Esgoto devidamente licenciada, garantindo
            assim a preservação de corretas práticas ambientais e preservação da natureza.
          </Text>
        </Col>
      </Grid>
    </View>
  )
}

export default ThirdPage
